import React from 'react'
import './task-card-reminder-slider.css'

import Axios from 'axios'
import { baseUrl } from '../../assets/Animations'

const TaskCardReminderSlider = ({closingReminderSlider, finalDateFormat, openModal2023}) => {

    const [reminderDetails, setReminderDetails] = React.useState({name: openModal2023.todoName, description: openModal2023.todoDescription, dueDate: ''})

    const addAReminder = () => {
        let event = {
            'summary': reminderDetails.name,
            'description': reminderDetails.description,
            'start': {
              'dateTime': `${reminderDetails.dueDate}:00-04:00`,
              'timeZone': 'America/Chicago',
            },
            'end': {
              'dateTime': `${reminderDetails.dueDate}:30-04:00`,
              'timeZone': 'America/Chicago',
            },
            'reminders': {
              'useDefault': false,
              'overrides': [
                {'method': 'email', 'minutes': 5},
              ],
            },
          };
        Axios.put(`${baseUrl}/setareminder`, {
            theReminder: event,
        })
        .then(response => {
            if(response.status === 200) {
                closingReminderSlider(false)
                setTimeout(() => alert('Reminder has been set!'), 50)
            }
        })
        .catch(e => {
            console.log(e)
            //props.setError({message: e.response.data, status: e.response.status})
        })
    }

    return(
        <div className='card-modal__reminder-slider' id="card-modal__reminder-slider">
            <div className='card-modal__reminder-slider__close-x__wrapper' onClick={() => closingReminderSlider(false)}>
                <div className='card-modal__reminder-slider__close-x'>close</div>
            </div>
            <div className='card-modal__reminder-slider__header'>Set A Reminder</div>
            <div className='card-modal__reminder-slider__input-labels'>Reminder Name</div>
            <input className='card-modal__reminder-slider__reminder-name' value={reminderDetails.name} onChange={(e) => setReminderDetails({...reminderDetails, name: e.target.value})} />
            <div className='card-modal__reminder-slider__input-labels'>Reminder Description</div>
            <textarea className='card-modal__reminder-slider__reminder-description' value={reminderDetails.description} onChange={(e) => setReminderDetails({...reminderDetails, description: e.target.value})} />
            <div className='card-modal__reminder-slider__input-labels'>Reminder Due Date</div>
            <input className='card-modal__reminder-slider__reminder-due-date' value={reminderDetails.dueDate} onChange={(e) => setReminderDetails({...reminderDetails, dueDate: e.target.value})} type="datetime-local" placeholder='yyyy-mm-ddT00:00' defaultValue={finalDateFormat}></input>
            <div className='card-modal__reminder-slider__submit-reminder' onClick={() => addAReminder()}>Create Reminder</div>
        </div>
    )
}
export default TaskCardReminderSlider;